import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-040d70f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "menuWithTabsContent"
}

import { BtnsForTabsMenuType } from '@/types';
import type { Component } from 'vue';
import { markRaw, onMounted, ref, Ref } from 'vue';
import { AnalyticalChart } from './index';


export default /*#__PURE__*/_defineComponent({
  __name: 'Analytics',
  setup(__props) {

const componentBtns: BtnsForTabsMenuType[] = [
  { id: 1, title: 'Аналитика', component: markRaw(AnalyticalChart) },
  { id: 2, title: 'Ос', component: markRaw(AnalyticalChart) },
  { id: 3, title: 'Активные', component: markRaw(AnalyticalChart) },
  { id: 4, title: 'Черновики', component: markRaw(AnalyticalChart) },
  { id: 5, title: 'Архив', component: markRaw(AnalyticalChart) },
];

const getActiveComponent = (btnId: string | number) => {
  return componentBtns.find(el => el.id === btnId)?.component;
};

const activeComponentBtnId: Ref<undefined | number | string> = ref(undefined);

const changeActiveBtn = (btnId: number | string) => {
  activeComponentBtnId.value = btnId;
};

onMounted(() => {
  changeActiveBtn(componentBtns[0].id);
});

return (_ctx: any,_cache: any) => {
  const _component_base_menu_with_tabs = _resolveComponent("base-menu-with-tabs")!

  return (_openBlock(), _createBlock(_component_base_menu_with_tabs, {
    activeComponent: activeComponentBtnId.value,
    componentBtns: componentBtns,
    bgColor: "#fff",
    withRadius: "",
    onChangeActiveBtn: _cache[0] || (_cache[0] = ($event: any) => (changeActiveBtn($event)))
  }, {
    content: _withCtx((contentProps) => [
      (getActiveComponent(contentProps.data))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(getActiveComponent(contentProps.data)), {
              key: contentProps.data
            }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["activeComponent"]))
}
}

})